/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiProfession } from '../models/jofi-profession';

@Injectable({
  providedIn: 'root',
})
export class JofiContentDeliveryProfessionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation professionsDeliveryControllerFindAll
   */
  static readonly ProfessionsDeliveryControllerFindAllPath = '/v1/content-delivery/professions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `professionsDeliveryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  professionsDeliveryControllerFindAll$Response(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiProfession>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryProfessionsService.ProfessionsDeliveryControllerFindAllPath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiProfession>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `professionsDeliveryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  professionsDeliveryControllerFindAll(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<Array<JofiProfession>> {

    return this.professionsDeliveryControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiProfession>>) => r.body as Array<JofiProfession>)
    );
  }

  /**
   * Path part for operation professionsDeliveryControllerFindOne
   */
  static readonly ProfessionsDeliveryControllerFindOnePath = '/v1/content-delivery/professions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `professionsDeliveryControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  professionsDeliveryControllerFindOne$Response(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<JofiProfession>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryProfessionsService.ProfessionsDeliveryControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiProfession>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `professionsDeliveryControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  professionsDeliveryControllerFindOne(params: {
    id: string;

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<JofiProfession> {

    return this.professionsDeliveryControllerFindOne$Response(params).pipe(
      map((r: StrictHttpResponse<JofiProfession>) => r.body as JofiProfession)
    );
  }

}
